import React from 'react';
/*import '../../styles/requestConfirmed.css';*/
import '../../styles/uploadimage.css';
import '../../styles/accept-buy-request.css';
import {Redirect } from 'react-router-dom'
export default class DeclineBuyRequestArtist extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            declined : false
        }
    }
    handleDeclineRequest(){
        this.setState({
            declined : true
        })
    }

    render() {
        if(this.state.declined){
            return(
                <Redirect push to = "/requestdeclined" />
            )
        }
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    DECLINE BUY REQUEST
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35 pl-0-s pr-0-s">
                                <div className="col-md-12">

                                    <div className="col-md-12">

                                        <h3 className="main-label ml-0"> Reason for declining the request?</h3>

                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="reason">Reason</label>
                                                <select className="form-control" id="reason" name="reason"
                                                        style={{"height": 40, "margin-bottom": 25}}>

                                                    <option value="My artwork is sold">My artwork is sold</option>
                                                    <option value="My artwork is not for sale">My artwork is not for
                                                        sale
                                                    </option>
                                                    <option value="My artwork details are incorrect">My artwork
                                                        details
                                                        are incorrect
                                                    </option>
                                                    <option value="This is not my artwork">This is not my artwork
                                                    </option>
                                                    <option value="Others">Others</option>

                                                </select>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="comments">Comments </label>
                                            </p>

                                            <textarea rows="4" cols="50" name="comments" id="comments"></textarea>


                                        </div>
                                    </div>

                                    <div className="padding-top-x20"></div>
                                    <div className="col-md-12 mt-15 mb-25">
                                        <p>
                                            <input type="submit" name="submit"
                                                   className="masterpieces-primary-buttons btn-primary"
                                                   onClick={this.handleDeclineRequest.bind(this)} style={{"margin-top": 25}}
                                                   value="Decline Buy Request"/>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div >

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_forms/decline-buy-request-artist.js